import { __rest, __assign } from 'tslib';
import React from 'react';
import { OpenNewIcon } from '@panwds/icons';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import { Body } from '../Typography/Body.esm.js';
import '../Tooltip/Tooltip.esm.js';

/**
 * An anchor element styled properly.
 */
function Link(_a) {
    var children = _a.children, _b = _a.external, external = _b === void 0 ? false : _b, addClassName = _a.addClassName, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId, props = __rest(_a, ["children", "external", "addClassName", "dataMetrics", "dataTestId"]);
    var attributes = {};
    if (external) {
        attributes["target"] = "_blank";
        attributes["rel"] = "noreferrer";
    }
    attributes["data-testid"] =
        dataTestId || "link-".concat(typeof children === "string" && testIdGen(children));
    var classes = classNames("dark:tw-text-blue-400", external && "tw-flex tw-items-center", addClassName);
    var datatestid = dataTestId || "link-".concat(typeof children === "string" && testIdGen(children));
    return (React.createElement(Body, __assign({ "data-metrics": dataMetrics, "data-testid": datatestid }, attributes, props, { as: "a", appearance: "link", addClassName: classes }),
        children,
        external && (React.createElement(OpenNewIcon, { size: "sm", "data-testid": "icon-external", className: "tw-ml-1" }))));
}

export { Link };
//# sourceMappingURL=Link.esm.js.map
